<template>
  <aside class="adBanner">
    <router-link
      :to="`/search/hospital/detail/${banner.hospitalId}`"
      class="link"
    >
      <picture>
        <source media="(max-width: 899px)" :srcset="banner.spImageSrc" />
        <img :src="banner.pcImageSrc" :alt="banner.hospitalName" />
      </picture>
    </router-link>
  </aside>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { AdBannerItem } from '@/types/AdBanner'

export default defineComponent({
  name: 'HomeAdBanner',

  props: {
    banner: {
      type: Object as PropType<AdBannerItem>,
      default: () => ({})
    }
    // NOTE: 抽象的なプロパティではなく親レイヤーで調整するのがいいと思います。
    // adType: {
    //   type: String
    // }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.adBanner {
  width: 100%;
  max-width: 712px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.link {
  display: inline-block;
}
</style>
